<template>
	<v-col class="balance-mutation">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Mutasi Saldo Belanja</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-cart</v-icon>
			<div class="pl-2">Transaksi Produk</div>
			<div class="px-2">/</div>
			<div>Mutasi Saldo Belanja</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center mb-5">
				<v-col cols="12" sm="6" md="4" xl="4" class="">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 blue--text font-weight-500">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
								<div class="font-size-10 cl-grey">Total Saldo Belanja</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>

				<v-col cols="12" sm="6" md="6" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<div v-if="!loading">
				<v-row v-if="listEwalletLog.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-vo-small table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="45%">Tanggal</th>
										<th class="text-center" width="10%">Tipe</th>
										<th class="text-right" width="45%">Jumlah (Rp)</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="ewallet in listEwalletLog" :key="ewallet.ewallet_product_log_id">
										<td class="text-left">{{ ewallet.ewallet_product_log_datetime | tanggaljam }}</td>
										<td class="text-center">
											<v-chip
												:color="(ewallet.ewallet_product_log_type == 'in') ? 'green' : 'error'"
												class="white--text font-weight-600"
												small
											>
												{{ (ewallet.ewallet_product_log_type == 'in') ? 'Masuk' : 'Keluar' }}
											</v-chip>
										</td>
										<td>
											<div class="text-right green--text font-weight-600" v-if="ewallet.ewallet_product_log_type == 'in'">{{ ewallet.ewallet_product_log_value | toNumber }}</div>
											<div class="text-right red--text text--lighten-1 font-weight-600" v-else>{{ ewallet.ewallet_product_log_value | toNumber }}</div>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listEwalletLog.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data saldo yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listEwalletLog.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="ewalletLogPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ ewalletLogPagination.total_display }} data dari total {{ ewalletLogPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';

export default {
	components: {
		ModalSearch
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('ewallet', ['listEwalletLog', 'ewalletLogPagination', 'ewalletSummary']),
	},
	methods: {
		...mapActions('ewallet', ['getEwalletLogAll', 'getEwalletLogIn', 'getEwalletLogOut', 'getEwalletSummary']),

		async getData() {
			this.loading = await true
			this.getEwalletSummary().then(() => {
				this.getEwalletLogAll(this.queryString({sort: 'ewallet_product_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalSearch.reset()
		},
		cari(type, data) {
			this.params = []
			if (type == 'in') {
				this.params.push(data.date)
				this.getEwalletLogIn(this.queryString({sort: 'ewallet_product_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
				})
			} else if (type == 'out') {
				this.params.push(data.date)
				this.getEwalletLogOut(this.queryString({sort: 'ewallet_product_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
				})
			} else {
				this.params.push(data.date)
				this.getEwalletLogAll(this.queryString({sort: 'ewallet_product_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalSearch.modalHide()
				})
			}
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Mutasi Saldo Belanja`)
		this.getData()
	}
};
</script>